<template>
    <div>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                    <el-card>

                        <el-form :model="pageObj" :inline="true" ref="formData" label-width="80px">
                            <el-form-item prop="postName" label="帖子标题">
                                <el-input clearable="true" v-model="pageObj.postName" @change="handleChange"
                                    placeholder="请输入帖子标题"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="anchorPageList()">查询</el-button>
                                <el-button @click="resetForm()">重置</el-button>
                            </el-form-item>
                        </el-form>
                        <!-- <el-button type="primary" @click="updateText()">发布帖子</el-button> -->
                        <div v-if="isEmpty" v-loading="loading" class="com_cont">

                            <el-table :data="tableData" border height="95%">
                                <el-table-column label="发帖人" prop="userName" align="center"></el-table-column>
                                <el-table-column width="200" show-overflow-tooltip="true" fit="false" label="发帖内容"
                                    prop="postContent" align="left"></el-table-column>
                                <el-table-column label="发帖时间" prop="createDate" align="center">
                                    <template slot-scope="scope">
                                        {{ dateFormat(scope.row.createDate) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="帖子类型" prop="postType" align="center">
                                    <template slot-scope="scope">
                                        {{ getPostTypeName(scope.row.postType) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="点赞数" prop="likesCount" align="center">
                                </el-table-column>
                                <!-- <el-table-column label="评论数" prop="commentCount" align="center"></el-table-column>
            <el-table-column label="收藏数" prop="suggestFlag" align="center"></el-table-column> -->
                                <el-table-column label="帖子标题" prop="postName" align="center">
                                </el-table-column>
                                <el-table-column align="center" label='操作' width="200">
                                    <template #default="{ row }">
                                        <el-popconfirm @confirm="deletePost(row)" title="确定删除该帖子吗？">
                                            <el-button slot="reference" type="text">
                                                删除
                                            </el-button>
                                        </el-popconfirm>
                                        <el-divider direction="vertical"></el-divider>
                                        <el-button type="text" @click="handleEdit(row, '查看')">
                                            查看
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination class="mt-15" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page.sync="page.index"
                                :page-sizes="page.sizes" :page-size.sync="pageObj.pageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </div>
                        <el-empty v-else></el-empty>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <edit ref="edit" />
    </div>
</template>

<script>
import { posts, deletePost } from '@/api/community'
import Edit from './components/postEdit.vue'
import moment from 'moment'
export default {
    components: { Edit },
    mounted() {
        this.posts()
    },
    data() {
        return {
            isEmpty: true,
            loading: false,
            activeName: '1',
            tableData: [],
            isDisabled: false,
            page: {
                index: 0,
                sizes: [10, 20, 30, 40],
            },
            formData: {
                postName: "",
            },
            // 分页传参
            pageObj: {
                pageNo: 0,
                pageSize: 10,
                postName: ""
            },
            total: 0,
            // 发帖传参
            // pushObj: {
            //     postContent: "fgsdgdf",
            //     postName: "你好",
            //     memberId: 1,
            //     postType: 1,
            //     popularFlag: 1
            // },
            // 查询
            postName: ''
        };
    },
    methods: {
        dateFormat(createDate) {
            return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
        },
        getPostTypeName(type) {
            switch (type) {
                case 'DAILY_GOSSIP':
                    return '日常杂谈';
                case 'EXPERIENCE_SHARING':
                    return '经验分享';
                case 'PROBLEM_FEEDBACK':
                    return '问题反馈';
                case 'PLATFORM_DIALOGUE':
                    return '平台对话';
                default:
                    return '其它';
            }
        },
        // 重置formData
        resetForm() {
            this.$refs.formData.resetFields()
            this.posts()
        },
        // 切换页码
        handleCurrentChange(index) {
            this.pageObj.pageNo = index - 1
            this.posts()
            console.log(index, '页码');

        },
        // 切换每页条目数
        handleSizeChange(index) {
            this.pageObj.pageSize = index
            this.posts()
            console.log(index, '条数');
        },
        // 查询
        anchorPageList() {
            this.pageObj.pageNo = 0
            this.posts()
        },
        handleChange(val) {
            //this.formData.postName = val
            this.pageObj.postName = val

            this.posts()
        },
        // 
        async posts() {
            this.loading = true
            await posts(this.pageObj).then((res) => {
                this.loading = false
                this.tableData = res.data.content
                this.tableData = res.data.content
                this.total = res.data.totalElements
                console.log(this.total)
            })
            // this.$api.posts(this.pageObj).then((res) => {
            //     this.loading = false
            //     this.tableData = res.data.data.content
            //     this.total = res.data.data.totalElements
            //     if (this.tableData.length == 0) {
            //         this.isEmpty = false
            //     } else {
            //         this.isEmpty = true
            //     }

            // }).catch((error) => {
            //     console.log(error,'请求过期');

            // })
        },
        // updateText() {
        //     this.$api.push(this.pushObj).then((res) => {
        //         console.log(res);
        //     })
        // },
        async deletePost(row) {
            await deletePost({ id: row.id }).then((res) => {
                if (res.code == 200) {
                    this.$message.success("删除成功")
                    this.posts()
                }
            })
        },
        handleEdit(row, title) {
            if (row) {
                this.$refs['edit'].showEdit(row, title)
            } else {
                this.$refs['edit'].showEdit(row, title)
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.grid-content {
    padding: 10px;
    height: 87vh;
    // border: 1px solid #050350;
    display: flex;
    flex-direction: column;
}

.com_header {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

::v-deep .el-card {
    height: 100% !important;


}

::v-deep .el-card__body {
    height: calc(100% - 117px) !important;
}

.el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-tooltip__popper {
    // max-width: none !important; /* 取消默认的最大宽度限制 */
    // white-space: pre-line;      /* 保留换行符，按段落显示 */
}

.com_cont {
    height: 100% !important;
}

// .el-table {
//     height: 95% !important;
//     overflow: auto;
// }
::v-deep .el-empty {
    height: 90%;
}
</style>